import { render, staticRenderFns } from "./NoteDetails.vue?vue&type=template&id=fb925c76&scoped=true&"
import script from "./NoteDetails.vue?vue&type=script&lang=js&"
export * from "./NoteDetails.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetails.vue?vue&type=style&index=0&id=fb925c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb925c76",
  null
  
)

export default component.exports